<template>
  <div class="time-resolution-select-wrapper">
    <el-select v-model="value" placeholder="请选择时间精度" @change="$emit('input', value)">
        <el-option v-for="item in options" :key="item.value"
        :label="item.label" :value="item.value">
        </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'TimeSelectComponent',
  props: [],
  data () {
    return {
      options: [{
        value: '15min',
        label: '15分钟'
      }, {
        value: 'hour',
        label: '小时'
      }, {
        value: 'day',
        label: '天'
      }, {
        value: 'month',
        label: '月'
      }, {
        value: 'year',
        label: '年'
      }],
      value: 'month'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.time-resolution-select-wrapper{
  margin-right: 10px;
}
</style>
